import commonFn from '@/commons/commonFunction';
import optionAPI from '@/apis/other/optionAPI';
import _ from 'lodash';
import listConfigDefault from '@/assets/config/listConfigDefault';
const state = {
  columnSetting: {
    listAllTask: [],
    listNeedToDo: [],
    listNeedToApprove: [],
    listAssignedByMe: [],
    listInvolve: [],
    listDone: [],
    listDraft: [],
    listReportOperateByMe: [],
    listReportMyOrg: [],
    listReportPersonality: [],
    listApproveUpdateDeadline: [],
  },
  columnSettingDefault: _.cloneDeep(listConfigDefault.columnSettingDefault)
};
const getters = {
  columnSetting(state) {
    return state.columnSetting;
  },
  columnSettingDefault(state) {
    return state.columnSettingDefault;
  },
};
const actions = {
  /**
   * goi api lay du lieu setting
   *
   * @param {L} context
   * @param {*} modeTab
   */
  getColumnSettingByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    let result = context.state.columnSetting[tabName];
    let defaultColumns = context.state.columnSettingDefault[tabName];
    if (result?.length == 0) {
      optionAPI
        .getDbOptions('columnSetting')
        .then(async(res) => {
          if (res.OptionValue && res.OptionValue[tabName]?.length > 0) {
            // Nếu tồn tại thì set data cho state
            let optionColumns = res.OptionValue[tabName];
            if (optionColumns.length < defaultColumns.length) {
              result = await context.dispatch('getNewOptionColumn', { defaultColumns, optionColumns });
            }else{
              result = optionColumns;
            }
          }
          else {
            // Nếu chưa có field thì lấy default
            result = defaultColumns;
          }

          context.commit('setColumnSettingByTab', { value: result, tabName });
        })
        .catch((err) => {
          // Nếu chưa có thì lấy default
          result = context.state.columnSettingDefault[tabName];
          context.commit('setColumnSettingByTab', { value: result, tabName });
        });
    }
  },

  /**
   * Lấy cột khi danh sách mặc định có cột mới mà option chưa có
   * NTDIEM 30/10/2023
   */
  getNewOptionColumn(context, {defaultColumns, optionColumns}) {
    let optionColumnsFieldName = optionColumns.map(item => item.dataField);
    let differenceColumns = defaultColumns.filter(item => !optionColumnsFieldName.includes(item.dataField));
    if (differenceColumns && differenceColumns.length > 0) {
      differenceColumns.forEach(item => {
        let itemIndex = defaultColumns.indexOf(item);
        optionColumns.splice(itemIndex, 0, _.cloneDeep(item));
      });
    }

    return optionColumns;
  },
  /**
   * goi mutation set gia trị mac dinh cho state tab
   * @param {*} context
   * @param {*} modeTab
   */
  setDefaultColumnByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    context.commit('setColumnSettingByTab', { value: context.state.columnSettingDefault[tabName], tabName });
    context.dispatch('updateColumnSettingDb')
  },
  /**
   * goi mutation set gia trị cho state tab
   * @param {*} context
   * @param {*} modeTab
   */
  setColumnSettingByTab(context, param) {
    let tabName = commonFn.getTabNameByMode(param.modeTab);

    context.commit('setColumnSettingByTab', { value: param.value, tabName });
    context.dispatch('updateColumnSettingDb')
  },
  /**
   * Goi api lưu thông tin cột vào db
   * @param {*} context
   */
  updateColumnSettingDb(context) {
    optionAPI.updateDbOptions({
      model: {
        optionKey: 'columnSetting',
        optionValueType: 3,
        optionValue: context.getters.columnSetting,
      },
    });
  },
};
const mutations = {
  /**
   * Set lai state
   * @param {*} state
   * @param {*} param
   */
  setColumnSettingByTab(state, param) {
    state.columnSetting[param.tabName] = param.value;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
